<template>
  <div>
    <div
      v-if="showLoader"
      class="spinner-border"
      style="margin: auto; display: block"
    ></div>
    <form v-else v-on:submit.prevent class="main_form_block">
          <div style = "border:1px #e2e2e2 solid; padding:20px" class = "col-sm-11">
            <div
              class="col-sm-12"
              style="
                border-bottom: 2px solid #3da3a7;
                margin-bottom: 10px;
                font-size: 20px;
                padding: 5px 0px 0px 5px;
              "
            >
              <label style="margin: 0px">Add Guardrail</label>
            </div>
            <div
              style="border: 1px #d4d4d4 solid; padding: 20px"
              class="col-md-12"
            >
              <div class="form-group row">
                <label for="tags" class="col-sm-2 col-form-label"
                  >Name<sup>*</sup></label
                >
                <div style="padding-right: 0px" class="col-sm-7 pr-5">
                  <span v-if="nameValidation" class="no-data-style"
                    >Provide the required field</span
                  >
                  <input
                    style="min-height: calc(1.5em + 0.75rem + 6px)"
                    @click="toggleValidation"
                    type="text"
                    placeholder="Name"
                    required="true"
                    v-model="title"
                    class="form-control custom-placeholder"
                    id="dailyBudget"
                    :disabled="showActions"
                  />
                </div>
              </div>
              <div style="margin-bottom: -1px" class="form-group row">
                <label for="tags" class="col-sm-2 col-form-label"
                  >Run Schedule<sup>*</sup></label
                >
                <div class="col-sm-8" style="padding: 0px; padding-right: 45px">
                  <span
                    v-if="runScheduleValidation"
                    class="col-sm-2 no-data-style"
                    >Provide the required field</span
                  >
                  <ReusableComponent
                    :isVendor="true"
                    label
                    isCalledFrom="all"
                    selection="Schedule options"
                    isMultiSelect="false"
                    @selectInputValue="selectInputValue"
                    :dataLoading="false"
                    :dropdownList="executeOnList"
                    :selectedValue="executeOn"
                    :selectedList="[]"
                    customPosition="col-sm-11"
                    :nonEditable="showActions"
                  />
                </div>
              </div>
              <div class="form-group row" v-if="showExecuteTimeList">
                <div class="col-sm-2 col-form-label"></div>
                <div class="col-sm-7 pr-5" style="padding-right: 0px">
                  <span
                    v-if="showExecuteTimeList && scheduleValidation"
                    class="no-data-style"
                    >Provide the required field</span
                  >
                  <multiselect
                    @input="toggleValidation"
                    v-model="executeTime"
                    v-if="showExecuteTimeList"
                    :options="executeTimeList"
                    :multiple="true"
                    ref="multiselect"
                    label="name"
                    track-by="id"
                    :taggable="false"
                    placeholder="Select"
                    class="form-control multi-dropdown select_filter"
                    :disabled="showActions"
                  ></multiselect>
                </div>
              </div>
              <div>
                <div class="row" style="margin-bottom: 10px">
                  <div
                    class="col-md-2 col-form-label"
                    style="padding-right: 0px"
                  >
                    <label style="padding: 0px"
                      >Target Measure<sup>*</sup></label
                    >
                  </div>
                  <div class="col-md-7 pr-5" style="padding-right: 0px">
                    <multiselect
                      v-model="source"
                      class="form-control multi-dropdown select_filter"
                      placeholder="Target"
                      label="name"
                      :disabled="true"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      @input="getTargetTypeList"
                      :options="sourceList ? sourceList : []"
                      track-by="name"
                      ref="multiselect"
                      :multiple="false"
                      :taggable="false"
                      style="height: 0px"
                    ></multiselect>
                  </div>
                  <span v-if="targetValidation" class="no-data-style"
                    >Select target to proceed</span
                  >
                </div>
                <div v-if="isShowTargetMeasure && source">
                  <div v-if="conditionValidation" class="form-group row">
                    <div class="col-md-2"></div>
                    <span style="margin-left: 15px" class="no-data-style"
                      >Make a selection to proceed</span
                    >
                  </div>
                  <div
                    class="form-group row"
                    v-for="(item, index) in conditionList"
                    :key="'prefilledActions_' + index"
                  >
                    <div class="col-md-2"></div>
                    <div class="col-md-3">
                      <multiselect
                        v-model="item.type"
                        class="form-control multi-dropdown select_filter"
                        placeholder="Type"
                        label="name"
                        deselectLabel
                        selectedLabel
                        selectLabel
                        :disabled="disableTheSelected[index] || showActions"
                        :options="
                          remainingTypeListToShow ? remainingTypeListToShow : []
                        "
                        track-by="id"
                        ref="multiselect"
                        @input="getTargetTypedata(item.type, index, item)"
                        @remove="removeTarget"
                        :multiple="false"
                        :taggable="false"
                        style="height: 0px"
                      ></multiselect>
                    </div>
                    <div
                      class="col-md-2"
                      v-if="item.type && !item.type.action"
                      style="padding: 0px"
                    >
                      <multiselect
                        @input="toggleValidation"
                        v-model="item.condition"
                        class="form-control multi-dropdown select_filter"
                        placeholder="Select"
                        label="name"
                        deselectLabel
                        selectedLabel
                        selectLabel
                        :disabled="disableTheSelected[index] || showActions"
                        :options="
                          remainingTypeListToShow.length > 0
                            ? rangeList
                              ? rangeList
                              : []
                            : []
                        "
                        track-by="id"
                        ref="multiselect"
                        :multiple="false"
                        :taggable="false"
                        @select="onSelectRange(item)"
                        style="height: 0px"
                      ></multiselect>
                    </div>
                    <div
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.attr_data_type == 'text' &&
                        item.condition.id != 'ispresent' &&
                        item.condition.id != 'isnotpresent'
                      "
                      class="col-md-3"
                      style="padding-right: 0px"
                    >
                      <input
                        style="min-height: calc(1.5em + 0.75rem + 6px)"
                        type="text"
                        placeholder="Text"
                        @click="toggleValidation"
                        required="true"
                        :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
                        v-model="item.value"
                        class="form-control"
                        id="dailyBudget"
                      />
                    </div>
                    <div
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.attr_data_type == 'single-select'
                      "
                      class="col-md-3"
                      style="padding-right: 0px"
                    >
                      <multiselect
                        v-model="item.value"
                        :options="valueList"
                        ref="multiselect"
                        label="name"
                        track-by="name"
                        @tag="addValue($event, index)"
                        open-direction="bottom"
                        :taggable="true"
                        :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
                        placeholder="Type"
                        class="form-control multi-dropdown select_filter"
                        selectLabel
                        deselectLabel
                        selectedLabel
                        :multiple="true"
                        @input="resetValue(item.value, index)"
                        style="height: 0px"
                      ></multiselect>
                    </div>
                    <div v-if="item.type && item.type.attr_data_type && item.type.id=='country' && item.type.attr_data_type=='multiselect'" class="col-md-3" style="padding-right: 0px;">
										<multiselect
											@input="toggleValidation"
											v-model="item.value"
											:options="countryList"
											:searchable="true"
											:loading = "tagSearchLoader"
											ref="multiselect"
											label="country_code"
											track-by="country_code"
											open-direction="bottom"
											placeholder="Country Code"
											class="form-control multi-dropdown col-md-12 select_filter"
											style="max-height:42px"
											id="countryData"
											:closeOnSelect = "true"
											:multiple="true"
                      :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
										></multiselect>
									</div>
                    <div
                      v-if="getValueTypeUrlLoader"
                      class="spinner-border"
                      style="margin-left: 30px; display: block"
                    ></div>
                    <div
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.id!='country' &&
                        (item.type.attr_data_type=='multiselect' || item.type.attr_data_type=='singleselect') &&
                        !getValueTypeUrlLoader
                      "
                      class="col-md-3"
                      style="padding-right: 0px"
                    >
                      <multiselect
                        v-model="item.value"
                        class="form-control multi-dropdown select_filter"
                        placeholder="Type"
                        label="name"
                        deselectLabel
                        selectedLabel
                        selectLabel
                        :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
                        :options="valueList"
                        track-by="name"
                        ref="multiselect"
                        @tag="addMultiValue($event, index, item.type.attr_data_type)"
                        :multiple="true"
                        openDirection="bottom"
                        :taggable="true"
                        @select="item.type.attr_data_type=='singleselect'? updateSingleValue($event,index) : '' "
                      ></multiselect>
                    </div>
                    <div
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.attr_data_type == 'number'
                      "
                      :class="
                        item.condition.name == 'Range' ||
                        item.condition.name == 'Not In Range'
                          ? 'col-md-1'
                          : 'col-md-3'
                      "
                      style="padding-right: 0px"
                    >
                      <input
                        style="min-height: calc(1.5em + 0.75rem + 6px)"
                        type="number"
                        placeholder="Value"
                        @blur="checkGreater($event, item, index)"
                        @click="
                          rangeValidationWrong = false;
                          toggleValidation();
                        "
                        required="true"
                        :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
                        v-model="item.value"
                        class="form-control"
                        id="dailyBudget"
                        onkeydown="javascript: return event.keyCode == 69 ? false : true"
                      />
                    </div>
                    <div
                      class="col-md-1"
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.attr_data_type == 'number' &&
                        item.condition &&
                        (item.condition.name == 'Range' ||
                          item.condition.name == 'Not In Range')
                      "
                      style="padding-right: 0px"
                    >
                      <input
                        style="min-height: calc(1.5em + 0.75rem + 6px)"
                        type="number"
                        @click="
                          rangeValidationWrong = false;
                          toggleValidation();
                        "
                        placeholder="Value"
                        required="true"
                        :disabled="showActions || disableTheSelected[index]"
                        @blur="checkSmall($event, item, index)"
                        v-model="item.value2"
                        class="form-control"
                        id="dailyBudget"
                        onkeydown="javascript: return event.keyCode == 69 ? false : true"
                      />
                    </div>
                    <div
                      class="col-md-2"
                      v-if="
                        item.type &&
                        item.type.attr_data_type &&
                        item.type.attr_data_type == 'boolean'
                      "
                    >
                      <multiselect
                        v-model="item.value"
                        class="form-control multi-dropdown select_filter"
                        placeholder="Select"
                        deselectLabel
                        selectedLabel
                        selectLabel
                        :disabled="
                          showActions ||
                          (remainingTypeListToShow.length > 0
                            ? disableTheSelected[index]
                            : true)
                        "
                        :options="booleanList"
                        ref="multiselect"
                        openDirection="bottom"
                      ></multiselect>
                    </div>
                    <div
                      v-if="item.type && item.type.is_of_attr"
                      class="col-md-2"
                    ></div>
                    <div
                      v-if="item.type && item.type.is_of_attr"
                      class="col-md-2"
                    ></div>
                    <div
                      style="margin-top: 10px; margin-left: 0px"
                      v-if="item.type && item.type.is_of_attr"
                      class="form-group row col-md-3"
                    >
                      <p class style="margin: 7px; margin-right: 10px">Of</p>
                      <div class="col-md-9">
                        <multiselect
                          @input="toggleValidation"
                          v-model="item.attribute"
                          class="form-control multi-dropdown select_filter"
                          placeholder="Select"
                          label="name"
                          deselectLabel
                          selectedLabel
                          selectLabel
                          :disabled="showActions || disableTheSelected[index]"
                          :options="
                            remainingTypeListToShow.length > 0
                              ? keywordAttributionList
                                ? keywordAttributionList
                                : []
                              : []
                          "
                          track-by="name"
                          ref="multiselect"
                          :multiple="false"
                          :taggable="false"
                          style="height: 0px"
                        ></multiselect>
                      </div>
                    </div>
                    <div
                      style="padding-top: 8px"
                      :style="
                        item.type && item.type.is_of_attr
                          ? 'margin-top:10px'
                          : ''
                      "
                    >
                      <button
                        @click="addConditionToList(item.type, index, 'AND')"
                        v-if="
                          conditionList.length != cloneOfTypeList.length &&
                          index == conditionList.length - 1 &&
                          item.type &&
                          (item.value.length ||
                            item.condition.id == 'ispresent' ||
                            item.condition.id == 'isnotpresent') &&
                          item.condition &&
                          ((item.value2 && item.condition.name == 'Range') ||
                            item.condition.name != 'Range') &&
                          source &&
                          typeOfOperation != 'OR'
                        "
                        class="btn btn-primary add-new-campaign"
                        :disabled="showActions"
                      >
                        AND
                      </button>
                      <button
                        @click="addConditionToList(item.type, index, 'OR')"
                        v-if="
                          conditionList.length != cloneOfTypeList.length &&
                          index == conditionList.length - 1 &&
                          item.type &&
                          (item.value.length ||
                            item.condition.id == 'ispresent' ||
                            item.condition.id == 'isnotpresent') &&
                          item.condition &&
                          ((item.value2 && item.condition.name == 'Range') ||
                            item.condition.name != 'Range') &&
                          source &&
                          typeOfOperation != 'AND'
                        "
                        class="btn btn-primary add-new-campaign"
                        :disabled="showActions"
                      >
                        OR
                      </button>
                      <button
                        v-if="
                          !(
                            automationId == 'null' && conditionList.length < 1
                          ) &&
                          item.type &&
                          item.value &&
                          item.condition &&
                          ((item.value2 && item.condition.name == 'Range') ||
                            item.condition.name != 'Range')
                        "
                        @click="removeConditionFromList(index, item.type)"
                        class="btn btn-primary add-new-campaign"
                        style="
                          padding: 0 10px;
                          margin-left: 15px;
                          background-color: red;
                        "
                        :disabled="showActions"
                      >
                        X
                      </button>
                    </div>
                  </div>
                  <div v-if="rangeValidationWrong" class="form-group row">
                    <div class="col-md-2"></div>
                    <span style="margin-left: 15px" class="no-data-style"
                      >Value1 should be less than value2</span
                    >
                  </div>
                  
                </div>
                <div
                  v-else-if="!isShowTargetMeasure"
                  class="spinner-border"
                  style="margin: auto; display: block"
                ></div>
                <div class="form-group row product-tags">
                  <div class="col-md-2 form-label" style="padding-right: 0px">
                    <label class="col-sm-2" style="padding: 0px"
                      >Tags<sup>*</sup></label
                    >
                  </div>
                  <div class="col-md-7 pr-5" style="padding-right: 0px">
                    <span v-if="tagValidation" class="no-data-style"
                      >Provide the required field</span
                    >
                    <multiselect
                      v-model="tagData"
                      :options="tagOptions"
                      :searchable="true"
                      :loading="tagSearchLoader"
                      ref="multiselect"
                      label="name"
                      track-by="name"
                      @tag="addTags"
                      open-direction="bottom"
                      :taggable="true"
                      placeholder="Tag"
                      class="form-control multi-dropdown col-md-12 select_filter"
                      style="max-height: 42px"
                      :multiple="true"
                      @select="selectTag"
                      id="tagData"
                      :closeOnSelect="false"
                      :disabled="showActions"
                    ></multiselect>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div
          class="col-sm-11"
          v-if="showActions"
          style="
            border-bottom: 2px solid #3da3a7;
            margin-bottom: 10px;
            font-size: 20px;
            padding: 5px 0px 0px 5px;
            margin-top: 30px;
          "
        >
          <label style="margin: 0px">Actions</label>
        </div>
        <div v-if="showActions">
          <button
            class="btn btn-primary"
            @click="
              addActionModal();
              showActions = false;
            "
          >
            Add Actions
          </button>
        </div>
        <div
          class="form-group text-center col-sm-12"
          style="margin-top: 40px; margin-bottom: 20px"
        >
          <button
            class="btn btn-secondary"
            id="cancel"
            v-on:click="navigateToList()"
            v-if="!showActions && !showLoader"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary"
            @click="submit"
            id="submit"
            v-if="!showActions && !showLoader"
          >
            Save
          </button>
          <button
            class="btn btn-primary"
            @click="
              navigateToGuardrail();
              showActions = false;
            "
            v-if="showActions"
          >
            Close
          </button>
        </div>
    <div v-if="showActionPopup">
      <AddAction
        :guardrailId="addedAutomation.id"
        :targetValue="addedAutomation.target"
        @navigateToList="navigateToList"
        @hideAddAction="hideAddAction"
      />
    </div>
  </div>
</template>


<script>
import AddAction from "@/components/define-guardrail/DefineActionInGuardrail.vue";
import Multiselect from "vue-multiselect";
import ReusableComponent from "@/components/Automation2/ReusableComponent.vue";
export default {
  name: "DefineNewGuardrailForm",
  components: {
    ReusableComponent,
    Multiselect,
    AddAction,
  },
  props: [],
  mounted() {
    const vm = this;
    this.type = this.$route.params.type;
    this.sourceList = [];
    if (this.type == "campaign") {
      this.list = this.campaignSelectedList;
      this.selectedType = "Campaign";
      this.source = {
        name: "Campaign",
      };
    }
    if (this.type == "campaign_group") {
      this.list = this.campaignGroupSelectedList;
      this.selectedType = "Campaign Group";
      this.source = {
        name: "Campaign Group",
      };
    }
    if (this.type == "asin") {
      this.selectedProducts = this.selectedProducts.map((e) => {
        e.type = "add asin";
        return e;
      });
      this.list = this.selectedProducts;
      this.selectedType = "Product";
      this.source = {
        name: "Product",
      };
    }
    if (this.type == "product") {
      this.selectedProducts = this.selectedProducts.map((e) => {
        e.type = "add asin";
        return e;
      });
      this.list = this.selectedProducts;
      this.selectedType = "Product";
      this.source = {
        name: "Product",
      };
    }

    this.sourceList.push(this.source);
    this.getTargetTypeList(this.source);
    this.showLoader = false;
    // this.$store.dispatch("automation/getAttributeList", {}).then((res) => {
    //   vm.sourceList = res;
    //   vm.showLoader = false;
    // });
    this.tagSearchLoader = true;
    this.$store.dispatch("automation/getTagsList", { q: "" }).then((res) => {
      vm.tagOptions = res;
      vm.tagSearchLoader = false;
    });
    this.$store.dispatch("accounts/getCountryList").then((res) => {
				   vm.countryList = res;
				   let data = vm.countryList.find((e) => e.market_place == 'US')
				   let index = vm.countryList.indexOf(data)
				   vm.countryList.splice(index, 1)
				   vm.countryList.unshift(data)
			   })
    $("#tagData").attr("autocomplete", "off");
  },
  watch: {
    targetType() {
      this.setRangeList(this.targetType);
    },
    sendNotification() {
      if (this.sendNotification) {
        this.addEmail();
      } else {
        this.emailList = [];
      }
    },
    source() {
      if (!this.source) {
        this.resetTargetData();
      }
    },
    typeList() {
      this.remainingTypeListToShow = JSON.parse(JSON.stringify(this.typeList));
    },
    conditionList() {},
  },
  data() {
    return {
      showActionPopup: false,
      type: "",
      list: [],
      selectedType: "",
      automationId: "null",
      cloneOfTarget: "",
      runScheduleValidation: false,
      conditionValidation: false,
      scheduleValidation: false,
      nameValidation: false,
      tagValidation: false,
      targetValidation: false,
      countryValidation:false,
      conditionList: [
        { type: "", condition: "", value: "", value2: "", attribute: "" },
      ],
      flag: false,
      sourceList: [],
      title: "",
      source: "",
      executeOn: "",
      typeList: [],
      cloneOfTypeList: [],
      remainingTypeListToShow: [],
      booleanList: ["TRUE", "FALSE"],
      executeOnList: [
        { id: "daily", name: "Daily" },
        { id: "weekly", name: "Weekly" },
        { id: "monthly", name: "Monthly" },
      ],
      integerList: [
        { id: "<", name: "<" },
        { id: ">", name: ">" },
        { id: "=", name: "=" },
        { id: "!=", name: "!=" },
        { id: "range", name: "Range" },
      ],
      rangeList: [],
      yearList: [
        { id: "jan", name: "January" },
        { id: "feb", name: "February" },
        { id: "mar", name: "March" },
        { id: "apr", name: "April" },
        { id: "may", name: "May" },
        { id: "jun", name: "June" },
        { id: "jul", name: "July" },
        { id: "aug", name: "August" },
        { id: "sep", name: "September" },
        { id: "oct", name: "October" },
        { id: "nov", name: "Novenber" },
        { id: "dec", name: "December" },
      ],
      weekList: [
        { id: "mon", name: "Monday" },
        { id: "tue", name: "Tuesday" },
        { id: "wed", name: "Wednesday" },
        { id: "thu", name: "Thursday" },
        { id: "fri", name: "Friday" },
        { id: "sat", name: "Saturday" },
        { id: "sun", name: "Sunday" },
      ],
      monthDateList: [
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
        { id: 6, name: 6 },
        { id: 7, name: 7 },
        { id: 8, name: 8 },
        { id: 9, name: 9 },
        { id: 10, name: 10 },
        { id: 11, name: 11 },
        { id: 12, name: 12 },
        { id: 13, name: 13 },
        { id: 14, name: 14 },
        { id: 15, name: 15 },
        { id: 16, name: 16 },
        { id: 17, name: 17 },
        { id: 18, name: 18 },
        { id: 19, name: 19 },
        { id: 20, name: 20 },
        { id: 21, name: 21 },
        { id: 22, name: 22 },
        { id: 23, name: 23 },
        { id: 24, name: 24 },
        { id: 25, name: 25 },
        { id: 26, name: 26 },
        { id: 27, name: 27 },
        { id: 28, name: 28 },
        { id: 29, name: 29 },
        { id: 30, name: 30 },
        { id: 31, name: 31 },
      ],
      valueList: [],
      showExecuteTimeList: false,
      executeTimeList: [],
      executeTime: [],
      showForm: false,
      showLoader: true,
      tagData: [],
      tagOptions: [],
      sendNotification: false,
      emailList: [],
      isShowTargetMeasure: true,
      disableTheSelected: [],
      keywordAttributionList: "",
      targetType: "",
      getValueTypeUrlLoader: false,
      tagSearchLoader: false,
      selectedTargetType: "",
      typeOfOperation: "",
      showActions: false,
      addedAutomation: {},
      rangeValidationWrong: "",
      countryData:null,
			countryList:[]
    };
  },
  computed: {
    vendorsList() {
      return this.$store.state.vendorList;
    },
    campaignSelectedList: {
      get() {
        return this.$store.state.campaign.campaignSelectedList;
      },
      set(val) {
        this.$store.state.campaign.campaignSelectedList = val;
      },
    },
    campaignGroupSelectedList: {
      get() {
        return this.$store.state.campaign.campaignGroupSelectedList;
      },
      set(val) {
        this.$store.state.campaign.campaignGroupSelectedList = val;
      },
    },
    selectedProducts: {
      set(val) {
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
  },
  methods: {
    updateSingleValue(data,index){
      let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]))
      dataClone.value = []
      dataClone.value.push(data)
      this.conditionList.splice(index, 1, dataClone)
    },
    checkSmall(event, item, index) {
      if (item.value) {
        if (
          parseInt(event.currentTarget.value) < parseInt(item.value) ||
          parseInt(event.currentTarget.value) == parseInt(item.value)
        ) {
          this.rangeValidationWrong = true;
          let data = this.conditionList;
          data[index].value2 = "";
          this.conditionList = JSON.parse(JSON.stringify(data));
        } else {
          this.rangeValidationWrong = false;
        }
      }
    },
    checkGreater(event, item, index) {
      if (item.value2) {
        if (
          parseInt(event.currentTarget.value) > parseInt(item.value2) ||
          parseInt(event.currentTarget.value) == parseInt(item.value2)
        ) {
          this.rangeValidationWrong = true;
          let data = this.conditionList;
          data[index].value = "";
          this.conditionList = JSON.parse(JSON.stringify(data));
        } else {
          this.rangeValidationWrong = false;
        }
      }
    },
    hideAddAction() {
      this.showActions = true;
      this.showActionPopup = false;
      $("#addAction").modal("hide");
    },
    navigateToList(data) {
      this.reset();
      if (data) {
        $("#addAction").modal("hide");
        this.$router.push({ path: data });
      } else {
        this.campaignSelectedList = [];
        this.campaignGroupSelectedList = [];
        this.selectedProducts = [];
        this.$store.state.campaign.campaignSelectedList = [];
        this.$store.state.campaign.campaignGroupSelectedList = [];
        this.$store.state.campaign.campaignToAddToGroupList = [];
        this.$store.state.product.actionSelectionControl = false;
        this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
        this.$store.state.campaign.actionSelectionControl = false;
        if (this.type == "campaign") {
          if (this.$store.state.refreshCampaign) {
            this.$store.state.refreshCampaign = false;
          } else {
            this.$store.state.calledFromCancel = true;
          }
          this.$router.push({ path: "/campaignList" });
        } else if (this.type == "campaign_group") {
          this.$store.state.calledFromCancel = true;
          this.$router.push({ path: "/campaignGroupList" });
        } else if (this.type == "asin") {
          this.$store.state.calledFromCancel = true;
          this.$router.push({ path: "/asinScraper" });
        } else if (this.type == "product") {
          this.$store.state.calledFromCancel = true;
          this.$router.push({ path: "/productlist" });
        }
      }
    },
    navigateToGuardrail() {
      this.showActionPopup = false;
      this.$router.push("/automation2");
    },
    addActionModal() {
      this.showActionPopup = true;
      this.$nextTick(() => {
        window.$("#addAction").modal({
          show: true,
        });
      });
    },
    addNewScope() {
      let payload = {
        selectedOptions: this.list,
        selectedKeywords: [],
        selectedType:
          this.selectedType == "Campaign Group"
            ? "CampaignGroup"
            : this.selectedType,
        automationId: this.addedAutomation.id,
        target: this.addedAutomation.target,
        file_ref: null,
      };
      this.showLoader = true;
      this.$store
        .dispatch("automation/addUpdateGuardRail", payload)
        .then((res) => {
          this.showLoader = false;
          this.showActions = true;
          this.campaignSelectedList = [];
          this.campaignGroupSelectedList = [];
          this.selectedProducts = [];
          this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
          this.$store.state.campaign.actionSelectionControl = false;
          this.$store.state.product.actionSelectionControl = false;
          this.$store.state.campaign.campaignToAddToGroupList = [];
        });
    },
    selectTag() {
      this.tagValidation = false;
    },
    addValue(name, index) {
      this.conditionList[index].value = [];
      var pay = { name: name };
      this.valueList.push(pay);
      this.conditionList[index].value.push(pay);
    },
    addMultiValue(name, index, type) {
      if(type=='singleselect'){
        let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]))
        dataClone.value = []
        this.conditionList.splice(index, 1, dataClone)
      }
      if (this.conditionList[index].value == "") {
        this.conditionList[index].value = [];
      }
      var pay = { name: name };
      this.valueList.push(pay);
      this.conditionList[index].value.push(pay);
    },
    resetValue(option, index) {
      if (option.length) {
        this.conditionList[index].value = option[option.length - 1];
      } else {
        this.conditionList[index].value = [];
      }
    },
    setRangeList(type) {
      console.log(this.source);

      this.rangeList = [];
      if (type == "multiselect" || type == "single-select" || type == "text" || type == "singleselect") {
        if (
          this.selectedTargetType &&
          this.selectedTargetType == "ASIN Status"
        ) {
          this.rangeList = [{ id: "equal", name: "Equals" }];
        } else if (
          this.selectedTargetType &&
          this.selectedTargetType == "Amazon Choice Attribute"
        ) {
          this.rangeList = [
            { id: "ispresent", name: "is Present" },
            { id: "isnotpresent", name: "is not Present" },
            { id: "contains", name: "Contains" },
            { id: "notcontains", name: " Not contains" },
          ];
        } 
        if(this.selectedTargetType && this.selectedTargetType == 'Country Code'){
						this.rangeList = [
							{ id: "contains", name: "Contains" }
						]
					}
        else {
          this.rangeList = [
            { id: "startwith", name: "Starts with" },
            { id: "endwith", name: "Ends with" },
            { id: "contains", name: "Contains" },
            { id: "notcontains", name: "Not Contains" },
            { id: "equal", name: "Equals" },
            { id: "notequals", name: "Not Equals" },
          ];
        }
      } else if (type == "boolean") {
        this.rangeList = [{ id: "equal", name: "Equals" }];
      } else if (type == "is") {
        this.rangeList = [{ id: "is", name: "Is" }];
      } else {
        this.rangeList = [
          { id: "<", name: "<" },
          { id: ">", name: ">" },
          { id: "=", name: "=" },
          { id: "!=", name: "!=" },
          { id: "range", name: "Range" },
          { id: "notinrange", name: "Not In Range" },
        ];
      }
      this.conditionList.splice(0, 0);
    },
    onSelectRange(item) {
      if (this.selectedTargetType && this.selectedTargetType == "ASIN Status") {
        item.value = "ASIN Not Found";
        this.disableTheSelected.push(true);
      }
    },
    toggleValidation() {
      this.runScheduleValidation = false;
      this.nameValidation = false;
      this.countryValidation = false;
      this.tagValidation = false;
      this.targetValidation = false;
      this.scheduleValidation = false;
      this.conditionValidation = false;
      this.rangeValidationWrong = false;
    },
    updateRemainingTypeListToShow(typeListFromResponse) {
      this.remainingTypeListToShow = JSON.parse(
        JSON.stringify(typeListFromResponse)
      );
    },
    searchFromDb(searchText) {
      if (searchText != "") {
        let payload = {
          q: searchText,
        };
        this.tagSearchLoader = true;
        const vm = this;
        this.$store.dispatch("automation/getTagsList", payload).then((res) => {
          vm.tagOptions = res;
          if (vm.tagData.length) {
            vm.tagOptions = vm.tagOptions.concat(vm.tagData);
            vm.tagOptions = new Set(vm.tagOptions);
            vm.tagOptions = Array.from(vm.tagOptions);
          }

          vm.tagSearchLoader = false;
        });
      }
    },
    removeSelectedTypeValueFromList(selectedType) {
      for (var i = 0; i < this.remainingTypeListToShow.length; i++) {
        if (this.remainingTypeListToShow[i].name == selectedType.name) {
          this.remainingTypeListToShow.splice(i, 1);
        }
      }
    },
    addDeSelectedTypeValueIntoList(deSelectedType) {
      var duplicate = false;
      for (var i = 0; i < this.remainingTypeListToShow.length; i++) {
        if (this.remainingTypeListToShow[i].name == deSelectedType.name) {
          duplicate = true;
          break;
        }
      }
      if (!duplicate) {
        this.remainingTypeListToShow.push(deSelectedType);
      }
    },
    addConditionToList(selectedType, index, typeOfOperation) {
      this.typeOfOperation = typeOfOperation;
      if (!this.flag) {
        if (selectedType.name != "ASIN Status") {
          this.disableTheSelected.push(true);
        }
      }
      this.removeSelectedTypeValueFromList(selectedType);
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      this.conditionList.push(conditionRow);
      this.flag = false;
    },
    removeConditionFromList(index, deSelectedType) {
      this.disableTheSelected.pop();
      if (deSelectedType) {
        this.addDeSelectedTypeValueIntoList(deSelectedType);
      }
      this.conditionList.splice(index, 1);
      if (this.conditionList.length == 1 || this.conditionList.length == 0) {
        this.typeOfOperation = "";
      }
      if (this.conditionList.length < 1) {
        var conditionRow = {
          type: "",
          condition: "",
          value: "",
          value2: "",
          attribute: "",
        };
        this.conditionList.push(conditionRow);
      }
    },
    addEmail() {
      if (this.emailList.length < 3) {
        this.emailList.push("");
      }
    },
    addTags(tag) {
      this.tagSearchLoader = false;
      this.tagValidation = false;
      const tagIs = {
        name: tag,
      };
      this.tagData.push(tagIs);
      if (this.tagOptions == undefined) {
        this.tagOptions = [];
        this.tagOptions.push(tagIs);
      } else {
        this.tagOptions.push(tagIs);
      }
    },
    getAllAutomationsList() {
      this.$store.dispatch("automation/getAutomations");
    },
    reset() {
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      (this.conditionList = []), this.conditionList.push(conditionRow);
      (this.title = ""),
        (this.source = ""),
        (this.executeOn = ""),
        (this.emailList = []),
        (this.executeTime = []);
      this.disableTheSelected = [];
      this.cloneOfTarget = [];
      this.showActionPopup = false;
      //(this.type = ""),
      //(this.typeObj = ""),
      //(this.condition = ""),
      //(this.conditionObj = ""),
      //(this.value = ""),
      //(this.valueObj = ""),
    },
    initialiseAutomationPopup() {
      var payload = {
        id: this.automationId,
      };
      const vm = this;
      this.$store
        .dispatch("automation/getAutomationDataById", payload)
        .then((res) => {
          vm.title = res.title;
          vm.conditionList =
            JSON.parse(JSON.stringify(res.trigger)).length > 0
              ? JSON.parse(JSON.stringify(res.trigger))
              : [{ type: "", condition: "", value: "", value2: "" }];
          vm.typeOfOperation =
            vm &&
            vm.conditionList &&
            vm.conditionList[0] &&
            vm.conditionList[0].operation_type
              ? vm.conditionList[0].operation_type
              : "";
          let executedata = JSON.parse(res.execute_on);
          vm.executeOn = executedata.id.toString();
          if (executedata.name == "Yearly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.yearList;
            vm.executeTime = res.execution_time;
          } else if (executedata.name == "Monthly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.monthDateList;
            vm.executeTime = res.execution_time;
          } else if (executedata.name == "Weekly") {
            vm.showExecuteTimeList = true;
            vm.executeTimeList = vm.weekList;
            vm.executeTime = res.execution_time;
          }
          vm.sendNotification = res.send_notification;
          vm.emailList = res.email ? res.email.split(",") : [];
          vm.tagData = res.tags ? JSON.parse(res.tags) : [];
          let storedSourceList = JSON.parse(res.target);
          vm.source = storedSourceList
            ? vm.sourceList.find((s) => s.name === storedSourceList.name)
            : null;
          let payload = {
            entityType: JSON.parse(res.target).name,
          };
          vm.cloneOfTarget = JSON.parse(
            JSON.stringify(JSON.parse(res.target).name)
          );
          vm.isShowTargetMeasure = false;
          vm.$store
            .dispatch("automation/getAttributeList", payload)
            .then((resp) => {
              //vm.targetType = resp[0].attr_data_type;
              resp = JSON.parse(resp[0].name);
              vm.cloneOfTypeList = resp;
              vm.updateRemainingTypeListToShow(resp);
              for (let i = 0; i < res.trigger.length; i++) {
                vm.disableTheSelected.push(true);
                vm.flag = true;
                res.trigger[i].trigger = JSON.parse(res.trigger[i].trigger);
                vm.conditionList[i].type = res.trigger[i].trigger
                  ? res.trigger[i].trigger.type
                  : null;
                vm.removeSelectedTypeValueFromList(vm.conditionList[i].type);
                if (
                  res.trigger[i].trigger.type.attr_data_type == "integer" ||
                  res.trigger[i].trigger.type.attr_data_type == "float"
                ) {
                  //vm.rangeList = vm.integerList;
                }
                vm.conditionList[i].condition = res.trigger[i].trigger
                  ? res.trigger[i].trigger.condition
                  : null;
                vm.conditionList[i].value = res.trigger[i].trigger.value;
                vm.conditionList[i].value2 = res.trigger[i].trigger.value2;
                if (
                  vm.keywordAttributionList.length < 1 &&
                  res.trigger[i].trigger.type.is_of_attr
                ) {
                  vm.isShowTargetMeasure = true;
                  vm.conditionList[i].attribute = res.trigger[i].trigger
                    ? res.trigger[i].trigger.attribute
                    : null;
                  vm.keywordAttributionList =
                    typeof res.trigger[i].trigger.type.is_of_attr == "string"
                      ? JSON.parse(res.trigger[i].trigger.type.is_of_attr)
                      : res.trigger[i].trigger.type.is_of_attr;
                } else {
                  vm.isShowTargetMeasure = true;
                }
              }
            });
          vm.showForm = true;
          vm.showLoader = false;
        });
    },
    getObjectFromId(id, list) {
      var object = {};
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].id) {
          object = list[i];
          break;
        }
      }
      return object;
    },
    getTargetTypeList(id) {
      this.toggleValidation();
      if (id && id.name) {
        this.resetTargetData();
        this.isShowTargetMeasure = false;
        let payload = {
          entityType: id.name,
        };
        this.$store
          .dispatch("automation/getAttributeList", payload)
          .then((res) => {
            //this.targetType = res[0].attr_data_type;
            this.typeList = JSON.parse(res[0].name);
            this.cloneOfTypeList = JSON.parse(res[0].name);
            this.isShowTargetMeasure = true;
          });
      }
    },
    removeTarget(data, id) {},
    selectInputValue(id, selection) {
      if (selection == "Schedule options") {
        this.executeTime = [];
        this.executeTimeList = [];
        this.executeOn = id ? id.id.toString() : "";
        this.updateExecuteTimeList(id);
      }
      this.toggleValidation();
    },
    resetTargetData() {
      this.typeList = [];
      this.cloneOfTypeList = [];
      //this.rangeList = [];
      this.valueList = [];
      this.disableTheSelected = [];
      var conditionRow = {
        type: "",
        condition: "",
        value: "",
        value2: "",
        attribute: "",
      };
      (this.conditionList = []), this.conditionList.push(conditionRow);
    },
    getTargetTypedata(data, index, item) {
      this.selectedTargetType = data.name;
      this.resetTarget(item, index);
      this.toggleValidation();
      if (data && data.is_of_attr) {
        this.keywordAttributionList = data.is_of_attr;
      }
      if (data) {
        this.conditionList[index].type = data;
      } else {
        this.conditionList[index].type = {};
      }

      this.conditionList[index].condition = "";

      this.targetType = (data || {}).attr_data_type;
      if (data && data.attr_data_type) {
        this.setRangeList(this.targetType);
      }

      if (data && data.value_type_url == "/vendor") {
        this.getValueTypeUrlLoader = true;
        const vm = this;
        this.$store.dispatch("getAllVendor").then((res) => {
          vm.valueList = res.filter((v) => v.name);
          vm.getValueTypeUrlLoader = false;
        });
      } else {
        this.valueList = [];
      }
    },
    resetTarget(item, index) {
      this.conditionList[index].type = [];
      this.conditionList[index].condition = [];
      this.conditionList[index].value = [];
    },
    selectExecuteTime() {},
    updateExecuteTimeList(obj) {
      if (obj) {
        if (obj.name == "Daily" || obj.name == "Hourly") {
          this.showExecuteTimeList = false;
        } else if (obj.name == "Weekly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.weekList;
        } else if (obj.name == "Monthly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.monthDateList;
        } else if (obj.name == "Yearly") {
          this.showExecuteTimeList = true;
          this.executeTimeList = this.yearList;
        }
      } else {
        this.showExecuteTimeList = false;
        this.executeTimeList = [];
        this.executeTime = [];
      }
    },
    submit() {
      if (!this.title.trim()) {
        this.nameValidation = true;
      } else if (!this.executeOn) {
        this.runScheduleValidation = true;
      } else if (this.showExecuteTimeList && this.executeTime.length < 1) {
        this.scheduleValidation = true;
      } else if (!this.source) {
        this.targetValidation = true;
      }
       else if (
        (this.conditionList.length < 2 &&
          (!this.conditionList[0].type ||
            (!this.conditionList[0].condition &&
              !this.conditionList[0].type.action) ||
            (!this.conditionList[0].value &&
              this.conditionList[0].condition.id != "ispresent" &&
              this.conditionList[0].condition.id != "isnotpresent") ||
            (this.conditionList[0].condition.name == "Range" &&
              !this.conditionList[0].value2) ||
            (this.conditionList[0].condition.name == "Not In Range" &&
              !this.conditionList[0].value2) ||
            (this.conditionList[0].type.is_of_attr &&
              !this.conditionList[0].attribute))) ||
        (this.conditionList[0].value &&
          Array.isArray(this.conditionList[0].value) &&
          this.conditionList[0].value.length == 0 &&
          this.conditionList[0].condition.id != "ispresent" &&
          this.conditionList[0].condition.id != "isnotpresent") ||
        (this.conditionList[0].condition &&
          Array.isArray(this.conditionList[0].condition) &&
          this.conditionList[0].condition.length == 0)
      ) {
        this.conditionValidation = true;
      } else if (this.tagData.length < 1) {
        this.tagValidation = true;
      }
      else {
        var vm = this;
        let executeTimeObj = this.executeOnList.find(
          (t) => t.id == this.executeOn
        );
        this.conditionList.forEach((condition, index) => {
          if (condition.id) {
            vm.conditionList[index] = JSON.parse(
              vm.conditionList[index].trigger
            );
          } else if (
            (condition.condition == "" && !condition.type.action) ||
            condition.type == "" ||
            (condition.value == "" &&
              condition.condition.id != "ispresent" &&
              condition.condition.id != "isnotpresent")
          ) {
            vm.conditionList.splice(index, 1);
          }
        });
        var payload = {
          title: this.title,
          executeOn: executeTimeObj,
          executeTime: this.executeTime,
          target: this.source,
          trigger: this.conditionList,
          email: this.emailList,
          sendNotification: this.sendNotification,
          tags: this.tagData,
          typeOfOperation: this.typeOfOperation,
        };
        this.automationId != "null" ? (payload["id"] = this.automationId) : "";
        this.showLoader = true;
        this.$store
          .dispatch("automation/addUpdateAutomation", payload)
          .then((response) => {
            vm.showLoader = false;
            vm.addedAutomation = response;
            vm.addNewScope();
          });
      }
    },
  },
};
</script>

<style lang="scss">
input#dailyBudget::placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.product-tags {
  .multiselect__tag {
    text-transform: none !important;
  }
}
.product-tags {
  .multiselect__single {
    text-transform: none !important;
    overflow: hidden;
  }
}
.product-tags {
  .multiselect__option span {
    text-transform: none !important;
  }
}
</style>
